import React, { createContext, useEffect, useState } from 'react';
import { getAllSystemConfigs, SystemConfig } from '../services/apiSLTP/systemConfig';
import { useSystemConfigsQuery } from '../hooks/queries/useSystemConfigsQuery';

type SystemConfigContextType = {
    configs?: SystemConfig[] | null;
    isLoading: boolean;
    getConfigValue: (key: string) => any;
    getConfigsGroup: (key: string) => SystemConfig[] | undefined;
    refetch: () => void;
};

export const SystemConfigContext = createContext<SystemConfigContextType | null>(null);

export const SystemConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { data: configs, isLoading, refetch } = useSystemConfigsQuery();

    const getConfigValue = (key: string): any => {
        return configs?.find((c) => c.key === key)?.value;
    };

    const getConfigsGroup = (group: string): SystemConfig[] | undefined => {
        return configs?.filter((c) => c.group === group);
    };

    return (
        <SystemConfigContext.Provider value={{ configs, isLoading, getConfigValue, getConfigsGroup, refetch }}>
            {children}
        </SystemConfigContext.Provider>
    );
};
